import useMyAccountRedesignEnabled from 'hooks/useMyAccountRedesignEnabled';
import { useIsEnrolledInVariant } from 'hooks/unleash/useIsEnrolledInVariant';
import { FEATURE_CHECKOUT_STORE_CREDIT_FORCE_START_DATE } from 'constants/features';
import { useStoreCreditEnabled } from 'hooks/useStoreCreditEnabled';

function withUseMyAccountRedesignHOC(Component, hookName) {
  const ComponentWithHooks = props => {
    const { isStoreCreditEnabled } = useStoreCreditEnabled();
    const { isEnrolled: forceStoreCreditStartDate } = useIsEnrolledInVariant({
      featureFlag: FEATURE_CHECKOUT_STORE_CREDIT_FORCE_START_DATE,
      isZapposOnly: false
    });
    const hookValue = useMyAccountRedesignEnabled();

    return (
      <Component
        {...props}
        {...{ [hookName]: hookValue }}
        isStoreCreditEnabled={isStoreCreditEnabled}
        forceStoreCreditStartDate={forceStoreCreditStartDate}
      />
    );
  };
  ComponentWithHooks.webpackChunkName = Component.webpackChunkName || Component.displayName || Component.name;
  ComponentWithHooks.displayName = `WithHooks(${Component.displayName || Component.name})`;
  ComponentWithHooks.beforeFetchDataOnServer = Component.beforeFetchDataOnServer;
  ComponentWithHooks.fetchDataOnServer = Component.fetchDataOnServer;
  return ComponentWithHooks;
}
export default withUseMyAccountRedesignHOC;
